module.exports = __webpack_public_path__ + "img/joinus-11.07357890.png";